module.exports = __webpack_public_path__ + "static/img/guangzhou2.54b4021.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/guangzhou2.jpg
// module id = Xi1V
// module chunks = 1